import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';

export namespace PartnerIncome {
  export interface SchemaPropertyDefinition {
    partnerIncome: OpportunitySchema.NumberPropertyDefinition;
  }
}

export namespace NonApplicantPartnerDetails {
  export interface SchemaPropertyDefinition {
    applicantPaysAllExpenses: OpportunitySchema.EmptyObjectPropertyDefinition;
    partnerContributesToExpenses: PartnerIncome.SchemaPropertyDefinition;
  }

  export enum PartnerContribution {
    ApplicantPaysAllExpenses = 'applicantPaysAllExpenses',
    PartnerContributesToExpenses = 'partnerContributesToExpenses'
  }

  export type SchemaContract =
    | {
        applicantPaysAllExpenses: {};
      }
    | {
        partnerContributesToExpenses: {
          partnerIncome?: number | null;
        };
      }
    | {}
    | undefined;

  export type Model = {
    status: PartnerContribution | null;
    partnerIncome: number | null;
  };

  export const SharedExpenseOptions = [
    {
      label: 'Applicant pays all expenses',
      value: PartnerContribution.ApplicantPaysAllExpenses
    },
    {
      label: 'Partner contributes to expenses',
      value: PartnerContribution.PartnerContributesToExpenses
    }
  ];

  export function toModel(contract: SchemaContract): Model | null {
    if (!contract) {
      return null;
    }

    if ('applicantPaysAllExpenses' in contract) {
      return {
        status: PartnerContribution.ApplicantPaysAllExpenses,
        partnerIncome: null
      };
    }

    if ('partnerContributesToExpenses' in contract) {
      return {
        status: PartnerContribution.PartnerContributesToExpenses,
        partnerIncome:
          contract.partnerContributesToExpenses.partnerIncome ?? null
      };
    }

    return null;
  }

  export function toSchemaContract(model: Model | null): SchemaContract {
    switch (model?.status) {
      case PartnerContribution.ApplicantPaysAllExpenses:
        return {
          applicantPaysAllExpenses: {}
        };
      case PartnerContribution.PartnerContributesToExpenses:
        return {
          partnerContributesToExpenses: {
            partnerIncome: model.partnerIncome
          }
        };
      default:
        return {};
    }
  }
}
